import { CommonStore } from '../common-store';
import api from '@/services/gateway/api';

const storeModule = new CommonStore(
  'camp/tv/channels',
  { name: 'camp.tv.channels.index' }
);

storeModule.state.listWithPaginate = [];

storeModule.mutations.setListWithPaginate = function (state, data) {
  state.listWithPaginate = data;
};

storeModule.actions.getListWithPaginate = function ({ commit }, payload) {
  return api.get('camp/tv/channels/paginate', { params: payload })
    .then((response) => {
      commit('setListWithPaginate', response.data);
      commit('totalRows', response.data.meta.total);
    });
};

storeModule.getters.getListWithPaginate = state => state.listWithPaginate;

storeModule.state.totalRows = null;

storeModule.getters.totalRows = state => state.totalRows !== null ? state.totalRows : 0;

storeModule.mutations.totalRows = function (state, data) {
  state.totalRows = data;
};

export default {
  namespaced: storeModule.namespaced,
  state: storeModule.state,
  getters: storeModule.getters,
  actions: storeModule.actions,
  mutations: storeModule.mutations
};
